module.exports = __webpack_public_path__ + "static/media/letter_o.7ce09615.m4a";